import { createSelector } from 'reselect'
import { get, values, filter, isEmpty } from 'lodash'

const getAllRevenueCenters = state => values(get(state, ['revenues', 'byId']))

export const getRevenues = createSelector([getAllRevenueCenters], allRevenueCenters =>
  filter(allRevenueCenters, revenue => !isEmpty(revenue.menus)),
)
